<template>
  <div class="b-vehicle-compare-card">
    <div class="mb-12">
      <LazyImage
        :image="image"
        :title="dictionary.buttonVehicleViewMoreText"
        class="cursor-pointer"
        @click="onClickButton" />
    </div>
    <div class="h4 extrabold mb-5">{{ item.make }} {{ item.model }}</div>
    <div class="semibold mb-8" style="flex: 1">
      {{ item.modelDescription }}
    </div>

    <div class="b-vehicle__totals mb-20">
      <div class="b-vehicle__price-w-vat" :class="{ 'is-active': vatIncluded }">
        <div class="bold mb-5">
          <span class="animate">
            <em v-if="vatIncluded">{{ item.pricePerMonthIncldVat }}</em>
            <em v-else>{{ item.pricePerMonth }}</em>
          </span>
        </div>

        <div class="form-check form-switch justify-content-center">
          <label
            class="form-check-label"
            :for="'vat' + item.id"
            :style="{ cursor: isPointer }">
            <span v-if="vatIncluded">
              {{ dictionary.vehicleVatIncluded }}
            </span>
            <span v-else>{{ dictionary.vehicleVatExcluded }}</span>
          </label>
          <input
            v-if="!isDisabled"
            :id="'vat' + item.id"
            v-model="vatIncluded"
            autocomplete="off"
            class="form-check-input"
            type="checkbox"
            role="switch"
            @click="$emit('changeVat', !vatIncluded, item.id)" />
        </div>
      </div>
    </div>
    <Anchor
      v-if="item.link"
      :item="item.link"
      class="btn btn-primary btn-full-width" />
  </div>
</template>

<script>
import * as lib from './../../../lib/lib'
import LazyImage from './../common/LazyImage.vue'
import Anchor from '../../components/common/Anchor.vue'

export default {
  components: { LazyImage, Anchor },
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  emits: ['changeVat'],
  data() {
    return {
      vatIncluded: false,
    }
  },
  computed: {
    isPointer() {
      if (!this.isDisabled) {
        return 'pointer'
      }
      return 'default'
    },
    isDisabled() {
      if (
        this.item.pricePerMonthIncldVatInteger > 0 &&
        this.item.pricePerMonthIncldVatInteger
      ) {
        return false
      }
      return true
    },

    image() {
      const images = this.item.galleryImages
      if (!images.length) {
        return null
      }
      return {
        url: images[0].url,
        alt: images[0].alt,
      }
    },
  },
  watch: {
    'item.vatIncluded'() {
      this.vatIncluded = this.item.vatIncluded
    },
  },
  methods: {
    onClickButton() {
      window.location.assign(this.item.link.url)
      lib.scrollToTop()
    },
  },
}
</script>
